import { PropsWithChildren } from 'react'
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch'

type ContactAutomationTaskLinkProps = PropsWithChildren & { id: number }

const ContactAutomationTaskLink = ({ children, id }: ContactAutomationTaskLinkProps) => (
  <LinkWithoutPrefetch
    className="primary-link w-full whitespace-normal"
    href={`/automation-rules/${id}`}
    target="__blank"
  >
    {children}
  </LinkWithoutPrefetch>
)

export default ContactAutomationTaskLink
